/// <amd-module name="TFS/Admin/Common/Controls/FileSelectorInput/FileSelectorInput" />
import * as React from "react";

import AdminResources = require("TFS/Admin/Common/Controls/Resources");
import { format } from "VSS/Core/Util/String";

export interface Props {
    allowedFileExtensions: string[];
    onload(fileDataUrl: string, fileByteArray: number[], errorMessage: string): void;
    maximumFileSize: number;
}
export interface State {
}
export class FileSelectorInput extends React.Component<Props, State> {
    public input: HTMLInputElement;
    private validFileExtensions: string;
    constructor(props: Props, context?: any) {
        super(props, context);
        this.state = {};
    }
    /**
     * @override
     */
    public render(): JSX.Element {
        let accept: string | null = null;
        if (this.props.allowedFileExtensions) {
            let fileExtensions: string[] = this.props.allowedFileExtensions.map(extension => {
                if (extension[0] !== ".") {
                    return "." + extension;
                } else {
                    return extension;
                }
            });
            accept = fileExtensions.join();
            this.validFileExtensions = fileExtensions.join(", ");
        }

        return <input type="file" id="idImage" style={{display: "none" }}
            ref={(ref) => { this.input = ref as HTMLInputElement; } }
            onChange={(event) => { this.fileSelected(event); 
                                    event.target.value = ''; } }   //This is need if we want to trigger onChange upon selecting the same file
            accept={accept!} />
    }

    private fileSelected(event: React.FormEvent<HTMLInputElement>) {
        let inputTarget: HTMLInputElement = event.target as HTMLInputElement;
        let files: FileList | null = inputTarget.files;

        let file: File | null = null;
        if (files && files.length > 0) {
            file = files.item(0);
        }

        if (!file) {
            return;
        }

        let isAllowed: boolean = false;

        let fileExtension: string | undefined = file.name.split(".").pop();
        fileExtension = "." + fileExtension;
        
        for (let j = 0; j < this.props.allowedFileExtensions.length; j++) {
            if (fileExtension!.toLocaleLowerCase() === this.props.allowedFileExtensions[j].toLocaleLowerCase()) {
                isAllowed = true;
                break;
            }
        }

        let errorMessage: string = "";
        
        if (!isAllowed)
        {
            errorMessage = format(AdminResources.FileTypeError, this.validFileExtensions.toLocaleUpperCase());
        }
        else if (file.size > this.props.maximumFileSize) {
            errorMessage = AdminResources.FileSizeError;
        }

        let fileByteArray: number[] = [];

        const reader: FileReader = new FileReader();   

        reader.onload = (fileReadEvent: any) => {
            if (fileReadEvent.target.readyState == FileReader.DONE) {
                var dataURL = fileReadEvent.target.result;
                var base64 = dataURL.split(",")[1];
                var array = this._base64ToArrayBuffer(base64);
                for (var i = 0; i < array.length; i++) {
                    fileByteArray.push(array[i]);
                 }
             }
            this.props.onload(dataURL, fileByteArray, errorMessage);
        };        

        reader.readAsDataURL(file); 
           
    }

    private _base64ToArrayBuffer(base64: string) {
        var binary_string =  window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array( len );
        for (var i = 0; i < len; i++)        {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;;
    }
}
